import { PRODUCT_STOCK_SERVICE_URL } from 'product/constants/constants'
import { getAkamaiFF } from 'utils/akamai/getAkamaiFF'
import { env } from 'utils/envManager'

import type { Stock } from '../../../types/Stock'
import { type GetProductStockProps, getProductStock } from '../getProductStock'

export const getServerProductStock = (
	params: GetProductStockProps
): Promise<Stock | null> => {
	const { productId } = params

	const { orchestrator: orchestratorFromAkamai } = getAkamaiFF()

	const baseUrl = `${orchestratorFromAkamai ? '/ws-online-orchestrator' : ''}/${PRODUCT_STOCK_SERVICE_URL}${productId}`

	const domain = orchestratorFromAkamai
		? env.NEXT_PUBLIC_SITE_BASE_URL
		: env.PRODUCT_SERVICE

	const url = new URL(baseUrl, domain)

	return getProductStock(params, url)
}
